import { ActionIcon, Button, Text } from "@mantine/core";
import { Form, Formik } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import { MdModeEditOutline } from "react-icons/md";
import * as yup from "yup";
import FormikAwareTextArea from "../../forms/formik/FormikAwareTextArea";

/**
 * This component is to edit inline text area field
 */
const TextAreaFieldInlineEdit = ({
  text,
  label,
  isEditable = false,
  onChange = () => {},
  className = "",
}: {
  text: string;
  label?: string;
  isEditable?: boolean;
  onChange?: (text: string) => void;
  className?: string;
}) => {
  const [editMode, setEditMode] = React.useState<boolean>(false);
  const { t } = useTranslation();

  const SCHEMA = yup.object({
    textArea: yup.string().max(1000, "Max character limit is 1000.").optional(),
  });

  /**
   * This method is to handle on change value of text area
   * @param event onchange text field data event
   */
  const handleSubmit = (value: { textArea: string }) => {
    onChange(value.textArea);
    setEditMode(false);
  };

  return (
    <div className={`w-100 ${className}`}>
      <div className={`row row-v-center row-space-between gap-4`}>
        {label && (
          <Text size="lg" weight={700}>
            {t(label ?? "")}
          </Text>
        )}
        {isEditable && !editMode && (
          <ActionIcon
            onClick={() => {
              setEditMode(true);
            }}
          >
            <MdModeEditOutline size="1.125rem" />
          </ActionIcon>
        )}
      </div>

      {editMode ? (
        <Formik
          validationSchema={SCHEMA}
          onSubmit={handleSubmit}
          initialValues={{ textArea: text }}
          enableReinitialize
        >
          {({ isValid, isSubmitting }) => (
            <Form className="row row-column gap-16 ">
              <div className={`form__row input-right-icon `}>
                <FormikAwareTextArea
                  name="textArea"
                  className="mt-10"
                  radius={"sm"}
                  minRows={4}
                />
              </div>
              <div className="form__row row gap-16 mt-10 row-column-phone-responsive">
                <Button
                  className="form-control"
                  type="submit"
                  mt={10}
                  size="md"
                  fullWidth
                  disabled={!isValid || isSubmitting}
                >
                  {t("update")}
                </Button>
                <Button
                  mt={10}
                  size="md"
                  className="form-control"
                  variant="outline"
                  fullWidth
                  onClick={() => setEditMode(false)}
                >
                  {t("cancel")}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      ) : (
        <div
          className={
            "word-break-break-all text-overflow-ellipsis overflow-hidden"
          }
        >
          {text}
        </div>
      )}
    </div>
  );
};

export default TextAreaFieldInlineEdit;
